import React from 'react'
import PropTypes from 'prop-types'
import './custom.css'
import Modal from '../Modal'

const WarningModal = ({ handleCancel, handleConfirm, translate, customClass, customText }) => (
  <Modal
    renderButton={false}
    onCloseModal={handleCancel}
    onConfirm={handleConfirm}
    size='sm'
    isOpen
    center
    showHeader={false}
    cancelButtonText={translate('button.cancel')}
    confirmButtonText={translate('out.without.save.confirm')}
    confirmType='danger'
    className={`schedule-block-edit-modal ${customClass}`}
  >
    <h3 className='delete w-100  '>
      <strong>{translate('out.without.save')}</strong>
    </h3>
    <em className='w-100'>{translate('missionMenu.warningModal.text1')}</em>
    <em style={{height: '50px'}}></em>
    <em className='w-100'>{customText || translate('out.without.save.msg.2')}</em>
  </Modal>
)

WarningModal.propTypes = {
  handleCancel: PropTypes.func.isRequired,
  handleConfirm: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
  customText: PropTypes.string.isRequired,
  customClass: PropTypes.string.isRequired
}

export default WarningModal
